import { Environment } from '../enums';

/**
 * Determine whether the application environment is in production - not the same as build environment
 */
export function isProduction(): boolean {
  return process.env.REACT_APP_ENV === Environment.Production;
}

export function getEnv(): Environment {
  return process.env.REACT_APP_ENV as Environment;
}

/**
 * Determines whether the code was built using the production mode using the react-scripts package
 */
export function isProductionBuild(): boolean {
  return process.env.NODE_ENV === Environment.Production;
}
